import React, { Fragment, Ref } from 'react';
import TextField, { TextFieldProps } from '@atlaskit/textfield';
import { Field, ErrorMessage, MessageWrapper } from '@atlaskit/form';
import { Inline } from '@atlaskit/primitives';

export interface FormTextFieldProps extends Omit<TextFieldProps, 'label'> {
  name: string;
  label: React.ReactNode;
  isLabelHidden?: boolean;
  invalidMessage?: React.ReactNode;
  testId?: string;
}

const FormTextField = (
  {
    name,
    label,
    isLabelHidden,
    invalidMessage,
    testId,
    isRequired,
    elemAfterInput,
    ...props
  }: FormTextFieldProps,
  ref: Ref<HTMLInputElement>
) => {
  const ariaDescribedBy = fieldProps => {
    const invalidMessageError = invalidMessage ? `${fieldProps.id}-error` : '';
    const ariaDescribedByMessage = props['aria-describedby'] ?? '';

    return invalidMessageError.concat(' ', ariaDescribedByMessage);
  };

  return (
    <Field
      name={name}
      label={!isLabelHidden && label}
      isRequired={isRequired}
      aria-required={isRequired}>
      {({ fieldProps }) => (
        <Fragment>
          <Inline alignBlock="center">
            <TextField
              {...fieldProps}
              {...props}
              isInvalid={!!invalidMessage}
              aria-describedby={ariaDescribedBy(fieldProps)}
              testId={testId}
              ref={ref}
              elemAfterInput={elemAfterInput}
            />
          </Inline>
          <MessageWrapper>
            {invalidMessage && (
              <ErrorMessage testId="form-text-field--input-invalid-error-message-field--idf-testid">
                {invalidMessage}
              </ErrorMessage>
            )}
          </MessageWrapper>
        </Fragment>
      )}
    </Field>
  );
};

export default React.forwardRef<HTMLInputElement, FormTextFieldProps>(FormTextField);
